// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Wge1S","buttonsContainer":"_1J7DWS"};